import { gql } from '@apollo/client';
import * as MENUS from '../library/constants/menus';
import { SiteInfoFragment } from '../fragments/GeneralSettings';
import { HeaderNavigationMenu, FooterNavigationMenu, FeaturedImage, PostsList, Posts, PostsHero, Heading, GlobalElements } from '@/components';
import { usePageLoadActions } from '@/hooks/usePageLoadActions';

export default function Component(props) {
	const { title: siteTitle, description: siteDescription } = props?.data?.generalSettings;
	const headerMenuItems = props?.data?.headerMenuItems?.nodes ?? [];
	const footerMenuItems = props?.data?.footerMenuItems?.nodes ?? [];
	const { name: tagName, posts, databaseId: tagId } = props.data?.nodeByUri;

	usePageLoadActions();

	return (
		<GlobalElements siteTitle={siteTitle} siteDescription={siteDescription} seo={{ title: `${siteTitle} Blog | ${tagName}`, description: `Blog articles tagged ${tagName}.` }} headerMenuItems={headerMenuItems} footerMenuItems={footerMenuItems}>
			<Heading className="sr-only">{`Articles tagged ${tagName}`}</Heading>
			<PostsHero title={`Latest ${tagName} articles`}>
				<PostsList posts={posts} cols={3} imageSizes='(max-width: 500px) 50vw, (max-width: 820px) 220px, (max-width: 1600px) 33vw, 455px' />
			</PostsHero>
			<section className="bg-topaz-100">
				<Posts tagId={tagId} title={`Explore ${tagName} articles`} />
			</section>
		</GlobalElements>
	);
}

Component.query = gql`
	${SiteInfoFragment}
	${HeaderNavigationMenu.fragments.entry}
	${FooterNavigationMenu.fragments.entry}
	${FeaturedImage.fragments.entry}
	query GetTagPage($uri: String!, $headerLocation: MenuLocationEnum, $footerLocation: MenuLocationEnum, $first: Int) {
		nodeByUri(uri: $uri) {
			... on Tag {
				databaseId
				name
				posts(first: $first) {
					edges {
						node {
							id
							title
							date
							uri
							...FeaturedImageFragment
							author {
								node {
									name
									avatar(size: 120) {
										url
									}
								}
							}
						}
					}
				}
			}
		}
		generalSettings {
			...SiteInfoFragment
		}
		footerMenuItems: menuItems(first: 100, where: { location: $footerLocation }) {
			nodes {
				...FooterNavigationMenuItemFragment
			}
		}
		headerMenuItems: menuItems(first: 100, where: { location: $headerLocation }) {
			nodes {
				...HeaderNavigationMenuItemFragment
			}
		}
	}
`;

Component.variables = ({ uri }) => {
	return {
		uri,
		first: 3,
		headerLocation: MENUS.HEADER_NAV,
		footerLocation: MENUS.FOOTER_NAV,
	};
};
